import * as Sentry from "@sentry/browser";

function timeout(ms: number) {
  return new Promise((resolve) => setTimeout(() => resolve, ms));
}

export const range = (n: number) => Array.from(Array(n).keys());

export function sum(array: Array<number>) {
  return array.reduce((sum, next) => sum + next, 0);
}

export function errorHandler(error) {
  if (process.env.REACT_APP_ENV !== "LOCAL") {
    Sentry.captureException(error);
  } else {
    console.error("promise error");
    console.error(error);
  }
}

export async function retryPromise(
  promise,
  maxRetries,
  options = { backOff: 1000 }
) {
  let err = null;
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await promise();
    } catch (e) {
      err = e;
      console.warn({ error: e, retry: i, maxRetries });
      if (i < maxRetries) await timeout(options.backOff);
    }
  }
  throw err;
}
